import { Injectable } from '@angular/core';
import { API_URLS } from '@app/constants/apiUrls';
import { ApiHelper } from '@app/helpers';

@Injectable({
  providedIn: 'root'
})
export class BrokerAdminService {

  constructor(private apiHelper: ApiHelper) { }

  list() {
    return this.apiHelper.get(API_URLS.BROKER_ADMIN)
  }

  add(payload: any) {
    return this.apiHelper.post(API_URLS.BROKER_ADMIN, payload)
  }

  update(id: any, payload: any) {
    return this.apiHelper.put(`${API_URLS.BROKER_ADMIN}/${id}`, payload)
  }
}
